<template>
  <Header />
  <div class="header_back"></div>
  <router-view />
  <SelfFooter />
  <!-- <ConnectUs /> -->
</template>
<script lang='ts'>
import { Options, Vue } from "vue-class-component";

import Header from "@/components/OfficialHeader.vue";
import SelfFooter from "@/components/OfficialFooter.vue";
import ConnectUs from "@/components/ConnectUs.vue";
@Options({
  components: {
    Header,
    SelfFooter,
    ConnectUs,
  },
})
export default class Home extends Vue {}
</script>
<style lang="less">
#app {
  font-family: 思源黑体;
  a {
    color: #000;
    text-decoration: none;
  }
}
.header_back {
  height: 72px;
}
</style>